export const data = [
    {
        id: '1909000',
        Task: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent.',
        // Assigned_To: 'Beltran',
        // Assignee: 'Romona',
        // Status: 'To-do',
        // Priority: 'Low',
        question: 'Energy generation and storage lorem ipsum dolor sit amet',
        Due_Date: '25-May-2020',
        dateTime: '12:00 1/10/2021',
        name: 'Investor Name',
        clientType: 'Current',
        avatar: ''
    },
    {
        id: '1909001',
        Task: 'Fix Styling',
        question: 'Energy generation and storage lorem ipsum dolor sit amet',
        category: 'Category',
        // Assigned_To: 'Dave',
        // Assignee: 'Romona',
        // Status: 'To-do',
        // Priority: 'Low',
        Due_Date: '26-May-2020',
        dateTime: '12:00 1/10/2021',
        name: 'Investor Name',
        clientType: 'Current',
        avatar: 'abc'
    },
    {
        id: '1909002',
        Task: 'Handle Door Specs',
        // Assigned_To: 'Roman',
        // Assignee: 'Romona',
        // Status: 'To-do',
        // Priority: 'Low',
        category: 'Category',
        question: 'Energy generation and storage lorem ipsum dolor sit amet',
        Due_Date: '27-May-2020',
        dateTime: '12:00 1/10/2021',
        name: 'Investor Name',
        clientType: 'Potential',
        avatar: 'cde'
    },
    {
        id: '1909003',
        Task: 'morbi',
        // Assigned_To: 'Gawen',
        // Assignee: 'Kai',
        // Status: 'Done',
        // Priority: 'High',
        question: 'Energy generation and storage lorem ipsum dolor sit amet',
        Due_Date: '23-Aug-2020',
        dateTime: '12:00 1/10/2021',
        clientType: 'Potential',
        category: 'Category',
        name: 'Investor Name',
        avatar: 'efg'
    },
    {
        id: '1909005',
        Task: 'proin',
        // Assigned_To: 'Bondon',
        // Assignee: 'Antoinette',
        // Status: 'In Progress',
        // Priority: 'Medium',
        dateTime: '12:00 1/10/2021',
        question: 'Energy generation and storage lorem ipsum dolor sit amet',
        Due_Date: '05-Jan-2021',
        name: 'Investor Name',
        clientType: 'Potential',
        avatar: 'kfg'
    }
];

export const columnsFromBackend = {
    ['1999222354444']: {
        title: 'Outstanding',
        items: data
    },
    ['1999222354445']: {
        title: 'Drafted',
        items: []
    },
    ['1999222354446']: {
        title: 'Resolved',
        items: []
    }
};

export const KanbanBoardStatus = {
    outstanding: 'Outstanding',
    archived: 'Archived',
    drafted: 'Drafted',
    resolved: 'Resolved'
};

export const KanbanBoardNewStatus = {
    active: 'Active',
    closed: 'Closed',
    open: 'Open'
};
export const InvestorStatus = {
    removed: 'Removed',
    deleted: 'Deleted',
    sample: 'Sample'
};

export const REMOVED_COMPANY_TOOL_TIP_MESSAGE = `Investor has removed this company from their company list.`;
export const DELETED_COMPANY_TOOL_TIP_MESSAGE = `Investor has deleted their account.`;
export const DELETED_USER = 'Deleted User';
export const individualCardOptions = [
    {
        name: 'Assign to categories',
        id: '998912'
    },
    {
        name: 'Assign to members',
        id: '998913'
    },
    {
        name: 'Archive',
        id: '998914'
    },
    {
        name: 'Report',
        id: '998915'
    }
];

export const extendCards = {
    top: false,
    right: true,
    bottom: false,
    left: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false
};

export const CANNOT_MOVE_CARD_TO_OUTSTANDING = `Cannot move card to outstanding as it is either open or closed.`;
export const CANNOT_MOVE_CARD_TO_OUTSTANDING_GUEST = `Question cannot be moved to Open or Outstanding as Guest question has been responded to.`;
export const ANNOUNCEMENT_REPLY_QUESTION = `This is a reply to an announcement. See the attached announcement.`;

export const ENQUIRY_POPOVER_LIST_LOCKED = [
    // {
    //     id: '12344555010',
    //     name: 'Undo',
    //     subText: 'Ctrl + Z',
    //     isDivider: false,
    //     isButton: false
    // },
    // {
    //     id: '12344555011',
    //     name: 'Re-do',
    //     subText: 'Ctrl + Y',
    //     isDivider: false,
    //     isButton: false
    // },
    {
        id: '12344555000',
        name: 'Copy all',
        isDivider: false,
        isButton: false,
        subText: ''
    },
    {
        id: '12344555001',
        name: 'Unlock notes',
        isDivider: true,
        subText: '',
        isButton: true
    }
];
export const ENQUIRY_POPOVER_LIST_UNLOCKED = [
    {
        id: '12344555010',
        name: 'Undo',
        subText: 'Ctrl + Z',
        isDivider: false,
        isButton: false
    },
    {
        id: '12344555011',
        name: 'Re-do',
        subText: 'Ctrl + Y',
        isDivider: false,
        isButton: false
    },
    {
        id: '12344555012',
        name: 'Copy all',
        isDivider: false,
        isButton: false,
        subText: ''
    },
    {
        id: '12344555013',
        name: 'Lock notes',
        isDivider: true,
        subText: '',
        isButton: true
    }
];
export const ColorSwatches = [
    {
        backgroundColor: '#579DFF',
        color: '#09326C',
        hoverBackgroundColor: '#CCE0FF'
    },
    {
        backgroundColor: '#8590A2',
        color: '#00214D',
        hoverBackgroundColor: '#DCDFE4'
    },
    {
        backgroundColor: '#4BCE97',
        color: '#164B35',
        hoverBackgroundColor: '#BAF3DB'
    },
    {
        backgroundColor: '#9F8FEF',
        color: '#352C63',
        hoverBackgroundColor: '#DFD8FD'
    },
    {
        backgroundColor: '#F87462',
        color: '#601E16',
        hoverBackgroundColor: '#FFD2CC'
    },
    {
        backgroundColor: '#60C6D2',
        color: '#1D474C',
        hoverBackgroundColor: '#C1F0F5'
    },
    {
        backgroundColor: '#E2B203',
        color: '#533F04',
        hoverBackgroundColor: '#FFE2BD'
    },
    {
        backgroundColor: '#CCE0FF',
        color: '#05C',
        hoverBackgroundColor: '#E9F2FF'
    },
    {
        backgroundColor: '#DCDFE4',
        color: '#00214D',
        hoverBackgroundColor: '#F1F2F4'
    },
    {
        backgroundColor: '#BAF3DB',
        color: '#216E4E',
        hoverBackgroundColor: '#DFFCF0'
    },
    {
        backgroundColor: '#DFD8FD',
        color: '#5E4DB2',
        hoverBackgroundColor: '#F3F0FF'
    },
    {
        backgroundColor: '#FFD2CC',
        color: '#AE2A19',
        hoverBackgroundColor: '#FFEDEB'
    },
    {
        backgroundColor: '#C1F0F5',
        color: '#206B74',
        hoverBackgroundColor: '#E3FAFC'
    },
    {
        backgroundColor: '#FFE2BD',
        color: '#7F5F01',
        hoverBackgroundColor: '#FFF7D6'
    }
];
